export class MaintenanceTaskCategory {
  id: number;
  name: string;
  description: string;
  /** When true, the category is pinned "always on top" (e.g. "Safety"). */
  pinned?: boolean;
}
